exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-bottom[data-v-47b970fc] {\n  border-radius: 0;\n}\n", ""]);

// exports
